import { useEffect } from 'react';

const SITE_NAME = 'AvantiTutor';

function upsert(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  return el;
}

function setMeta(attr, key, content) {
  if (content == null) return;
  const el = upsert(`meta[${attr}="${key}"]`, () => { const m = document.createElement('meta'); m.setAttribute(attr, key); return m; });
  el.setAttribute('content', content);
  el.setAttribute('data-seo', '1');
}

export default function Seo({ title, description, image, type = 'website', path, jsonLd = [], noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} – Individuelle Nachhilfe`;
    const url = `${window.location.origin}${path ?? window.location.pathname}`;
    document.title = fullTitle;
    setMeta('name', 'description', description || '');
    setMeta('name', 'robots', noindex ? 'noindex,follow' : 'index,follow');
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description || '');
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('property', 'og:locale', 'de_DE');
    setMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description || '');
    if (image) { setMeta('property', 'og:image', image); setMeta('name', 'twitter:image', image); }
    else { document.head.querySelector('meta[property="og:image"]')?.remove(); document.head.querySelector('meta[name="twitter:image"]')?.remove(); }

    const canonical = upsert('link[rel="canonical"]', () => { const l = document.createElement('link'); l.rel = 'canonical'; return l; });
    canonical.href = url;

    document.head.querySelectorAll('script[data-jsonld]').forEach((s) => s.remove());
    jsonLd.filter(Boolean).forEach((obj, i) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.dataset.jsonld = String(i);
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
    return () => { document.head.querySelectorAll('script[data-jsonld]').forEach((s) => s.remove()); };
  }, [title, description, image, type, path, noindex, JSON.stringify(jsonLd)]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export const breadcrumbJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({ '@type': 'ListItem', position: i + 1, name: it.name, item: `${window.location.origin}${it.path}` })),
});
